// extracted by mini-css-extract-plugin
module.exports = {"donateBtn":"donateButton_donateBtn__2pqUA"};